import React, { useState, useMemo } from 'react';
import { PageHeader, Icon } from '@salesforce/design-system-react';
import { Button, ButtonGroup, PageHeaderControl } from '@salesforce/design-system-react';
import ContractTable from './contractTable';
import AddContract from '../../../../components/Modal/addContract';
import { getCurrentUser } from '../../../../services/auth';
import { getSyncTime } from '../../../../services/snapshot';

const Contract = () => {
  const [openAddContractModal, setOpenAddContractModal] = useState(false);
  const user = getCurrentUser();
  const isSnapshot = useMemo(() => !!getSyncTime(), []);

  return (
    <>
      <div>
        <PageHeader
          icon={
            <Icon
              assistiveText={{ label: 'User' }}
              category="standard"
              name="catalog"
              containerStyle={{
                backgroundColor: '#48C3CC',
              }}
            />
          }
          info="Below are all your saved contract/protocol addresses"
          label="Address Book"
          title="Contracts Addresses"
          variant="object-home"
          onRenderActions={() => (
            <>
              {
                ((user.account_type === 'organization' && user.role !== 'user') || user.account_type === 'standard') && (
                  <PageHeaderControl>
                    <ButtonGroup id="button-group-page-header-actions">
                      <Button label={'Add Contract'} onClick={() => setOpenAddContractModal(true)} disabled={isSnapshot} />
                    </ButtonGroup>
                  </PageHeaderControl>
                )
              }
            </>
          )}
        />
      </div>
      <div>
        <ContractTable isSnapshot={isSnapshot} />
      </div>

      <AddContract
        openModal={openAddContractModal}
        closeModal={() => setOpenAddContractModal(false)}
      />
    </>
  );
};

export default Contract;
